module.exports = __webpack_public_path__ + "img/two-dimensional_3.9b09a911.png";